<template>
	<div v-if="loading">
		<LoadingSpinner :message="'Cargando datos'" />
	</div>
	<div class="form-body" v-else>
		<b-breadcrumb :items="getBreadCrumbItems"></b-breadcrumb>
		<b-card>
			<h3>
				<span>Etiqueta</span>
			</h3>
			<InfoTag :tag="tag" :editMode="true" @updated="handleUpdated" />
		</b-card>
		<!-- Toast -->
		<b-toast id="my-toast-success" toaster="b-toaster-bottom-right" no-close-button>
			<div class="d-flex">
				<div class="icon">
					<img src="../../assets/icons/heart-color.svg" alt="edit" />
				</div>
				<p>Tag/Etiqueta creada correctamente</p>
			</div>
		</b-toast>
	</div>
</template>

<script>
import { mapActions } from 'vuex';
import LoadingSpinner from '@/components/LoadingSpinner.vue';
import InfoTag from '@/views/tags/components/InfoTag.vue';

export default {
	name: 'ViewTag',

	components: { InfoTag, LoadingSpinner },

	data: () => ({
		tagId: '',
		tag: null,
		loading: true
	}),

	created() {
		this.tagId = this.$route.params.id;
	},

	async mounted() {
		this.loading = true;
		try {
			this.tag = await this.getTagById({ id: this.tagId });
		} catch (error) {
			console.log(error);
		} finally {
			this.loading = false;
		}
	},

	methods: {
		...mapActions('tagsStore', ['getTagById']),
		handleUpdated() {
			this.$bvToast.show('my-toast-success');
		}
	},
	computed: {
		getBreadCrumbItems() {
			return [
				{
					text: `Etiquetas`,
					to: '/etiquetas'
				},
				{
					text: `Editar Etiqueta`,
					active: true
				}
			];
		}
	}
};
</script>
